// extracted by mini-css-extract-plugin
module.exports = {"input":"Address_input__H3Dko","text":"Address_text__1GBzq"};